
import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import CreateUpdateStreetLightPresenter from "../../../../features/planBT/components/Streetlight/CreateUpdateStreetLight/CreateUpdateStreetLightPresenter";

export default function CreateStreetLightPage() {
    const {navigate} = useMicroNavigator()
  return (
    <div style={{color: "white"}}>
        <HeaderWidget variant="dark" withBackBtn handleBackBtn={() => navigate('list')}>Nouveau Lampadaire</HeaderWidget>
        <CreateUpdateStreetLightPresenter />
    </div>
  )
}
